<script setup>
import { ref, defineProps, defineEmits, onMounted, reactive } from "vue";
import ElevateESFEvent from "./ElevateESFEvent.vue";

const props = defineProps({
  data: Array,
  type: String,
  title: String,
  licenceName: String,
  headers: Array,
});

const emit = defineEmits(["back"]);
const selectedEsfSession = ref("");
const selectedEsfSessionUsername = ref("");
const selectedEsfSessionSerialNumber = ref("");
const searchValue = ref("");
const activeTab = ref("main");
const tableData = reactive([]);

onMounted(() => {
  if (props.headers?.length) {
    headers = props.headers;
  }
  tableData.length = 0;
  props.data.forEach((item) => {
    if (item.sessionStart) {
      tableData.push({
        ...item,
        sessionStartTimestamp: item.sessionStart?.timestamp,
      });
    } else {
      tableData.push({
        ...item,
        sessionStartTimestamp: item.timestamp,
        sessionStart: {
          username: item.username,
          serialNumber: item.serialNumber,
        },
      });
    }
  });
});

function selectEsf(item) {
  console.log(item);
  if (item.customReference) {
    selectedEsfSessionUsername.value = item.sessionStart.user;
    selectedEsfSessionSerialNumber.value = item.serialNumber;
    selectedEsfSession.value = item.customReference;
    activeTab.value = "esf";
  }
}

function closeEsf() {
  selectedEsfSession.value = "";
  selectedEsfSessionUsername.value = "";
  selectedEsfSessionSerialNumber.value = "";
  activeTab.value = "main";
}

function formatDate(date) {
  if (!date) return "";
  return new Date(date).toLocaleString();
}

var headers = reactive([
  { text: "Username", value: "sessionStart.username", sortable: true },
  { text: "Serial Number", value: "sessionStart.serialNumber", sortable: true },
  {
    text: "Date Time Requested",
    value: "sessionStartTimestamp",
    sortable: true,
  },
  { text: "Application Path", value: "path", sortable: true },
  { text: "App Bundle ID", value: "CFBundleIdentifier", sortable: true },
  { text: "", value: "actions", sortable: false },
]);

function searchFields() {
  var result = [];
  headers.forEach((header) => {
    if (header.text != "Actions") result.push(header.value);
  });
  return result;
}
</script>

<template>
  <v-window v-model="activeTab">
    <v-window-item value="main">
      <v-row>
        <v-col cols="auto">
          <v-btn @click="$emit('back')" prepend-icon="mdi-arrow-left">
            Back
          </v-btn>
        </v-col>
        <v-col>
          <v-text-field
            density="compact"
            variant="underlined"
            hide-details
            label="Search..."
            v-model="searchValue"
          />
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto">
          <h2>{{ props.title }}</h2>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer></v-spacer>
      </v-row>
      <v-row>
        <v-col cols="12">
          <EasyDataTable
            :items="tableData"
            :headers="headers"
            :search-value="searchValue"
            :search-field="searchFields()"
            theme-color="#e7541e"
            alternating
          >
            <template #item-sessionStartTimestamp="item">
              {{ formatDate(item.sessionStartTimestamp) }}
            </template>

            <template #item-actions="item">
              <v-btn
                v-if="item.sessionStart && item.customReference"
                icon
                size="small"
                variant="text"
                density="compact"
                @click="selectEsf(item)"
              >
                <v-icon class="mx-1" color="primary"
                  >mdi-text-box-multiple-outline</v-icon
                >
                <v-tooltip
                  activator="parent"
                  location="start"
                  text="View Session Logs"
                />
              </v-btn>
            </template>
          </EasyDataTable>
        </v-col>
      </v-row>
    </v-window-item>

    <v-window-item value="esf">
      <ElevateESFEvent
        :licenceName="props.licenceName"
        :serialNumber="selectedEsfSessionSerialNumber"
        :username="selectedEsfSessionUsername"
        :eventReference="selectedEsfSession"
        @back="closeEsf()"
      />
    </v-window-item>
  </v-window>
</template>
